import { z } from 'zod'

const accessTokenSchema = z.object({
  exp: z.coerce.number(),
  realm_access: z.object({
    roles: z.array(z.string()),
  }),
  resource_access: z
    .object({
      'fvl-frontend': z
        .object({
          roles: z.array(z.string()),
        })
        .optional(),
    })
    .optional(),
  preferred_username: z.string(),
})

type AccessTokenData = z.infer<typeof accessTokenSchema>

export { accessTokenSchema, type AccessTokenData }
